import React from "react";
import { Container } from "react-bootstrap";
import { AcademyPolicyForm } from "../components/AcademyPolicyForm";

function PoliticasPage() {
  return (
    <Container fluid className="py-3">
      <h4 className="mb-3">Políticas de la academia</h4>
      <p className="text-muted mb-4">
        Configura las reglas operativas de tu academia. Estos valores se
        aplican automáticamente al agendar y cancelar clases.
      </p>
      <AcademyPolicyForm />
    </Container>
  );
}

export { PoliticasPage };
